import { theme } from "antd";

export function TextHighlighter(props: { text: string; terms: string[] }) {
  const { token } = theme.useToken();
  const lowerText = props.text.toLocaleLowerCase();
  const lowerTerms = props.terms.map((term) => term.toLocaleLowerCase());
  let i = 0;
  let text = "";
  const spans: { text?: string; match?: string }[] = [];
  while (i < lowerText.length) {
    const match = lowerTerms.find(
      (term) => lowerText.slice(i, i + term.length) === term
    );
    if (match) {
      if (text) spans.push({ text });
      text = "";
      spans.push({ match: props.text.slice(i, i + match.length) });
      i += match.length;
    } else {
      text += props.text.at(i);
      i += 1;
    }
  }
  if (text) spans.push({ text });
  return (
    <>
      {spans.map((span, i) => (
        <span
          style={{
            backgroundColor: Boolean(span.match)
              ? token.colorHighlight
              : "transparent",
          }}
          key={i}
        >
          {span.text || span.match}
        </span>
      ))}
    </>
  );
}
